// extracted by mini-css-extract-plugin
module.exports = {"headinglarge":"PageNotPermission_headinglarge_1bqas","textlarge":"PageNotPermission_textlarge_21ww8","centered":"PageNotPermission_centered_1Wxj0"};